import { ref } from 'vue';

const component = ref(null);
const show = ref(false);
const props = ref({});

export function useModal() {
  const showModal = (newProps = {}) => {
    props.value = newProps;
    show.value = true;
  };

  const hideModal = () => {
    show.value = false;
  };

  return {
    component,
    show,
    props,
    showModal,
    hideModal
  };
}